const getClUsrId = state => state.claud.get('session')?.clusrId;

export default {
    getClUsrId,
};
